import React, { ReactNode } from "react";
import * as FaIcons from "react-icons/fa";
//import * as AiIcons from "react-icons/ai";
import * as RiIcons from "react-icons/ri";
//import { FcDataConfiguration } from "react-icons/fc";
import { IoMdExit } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { TbReportSearch } from "react-icons/tb";
import { FaGear } from "react-icons/fa6";
import { FaUserGear } from "react-icons/fa6";
//import { GiBiceps } from "react-icons/gi";
import { FaRegRectangleList } from "react-icons/fa6";
import { FaAddressCard } from "react-icons/fa6";
import { MdPaid } from "react-icons/md";

export type SidebarItem = {
  title: string;
  path: string;
  icon: ReactNode;
  cName: string;
  hasOnClick: boolean;
  iconClosed?: ReactNode;
  iconOpened?: ReactNode;
  subNav?: SidebarItem[];
};

export const SidebarData: SidebarItem[] = [
  {
    title: "Registrar Cliente",
    path: "/client-registry",
    icon: <FaAddressCard />,
    cName: "nav-text",
    hasOnClick: false,
  },
  {
    title: "Asignar Plan",
    path: "/client-plans",
    icon: <FaIcons.FaCreditCard />,
    cName: "nav-text",
    hasOnClick: false,
  },
  {
    title: "Registrar Pago",
    path: "/payment-registry",
    icon: <MdPaid />,
    cName: "nav-text",
    hasOnClick: false,
  },
  {
    title: "Perfil",
    path: "/profile",
    icon: <FaIcons.FaUser />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Ejercicios",
    path: "/exercises",
    icon: <FaIcons.FaDumbbell />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Rutinas",
    path: "/trainings",
    icon: <FaRegRectangleList />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Mis Rutinas",
    path: "/my-routines",
    icon: <FaRegRectangleList />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Mis Entrenamientos",
    path: "/my-trainings",
    icon: <FaIcons.FaRunning />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Mis Clases",
    path: "/my-classes",
    icon: <FaIcons.FaRegCalendarAlt />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Mis Clases",
    path: "/instructor-classes",
    icon: <FaIcons.FaRegCalendarAlt />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Mis Pagos",
    path: "/my-payments",
    icon: <FaIcons.FaRegMoneyBillAlt />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Convenios",
    path: "/agreements",
    icon: <FaIcons.FaTicketAlt />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Administración",
    path: "#",
    icon: <FaUserGear />,
    cName: "nav-text",
    hasOnClick: false,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Usuarios",
        path: "/users",
        icon: <FaIcons.FaUser />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Clientes",
        path: "/clients",
        icon: <CgProfile />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Planes",
        path: "/plans",
        icon: <FaIcons.FaCreditCard />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Pagos",
        path: "/payments",
        icon: <FaIcons.FaRegMoneyBillAlt />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Clases",
        path: "/classes",
        icon: <FaIcons.FaRegCalendarAlt />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Reportes",
        path: "/reports",
        icon: <TbReportSearch />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Convenios",
        path: "/agreementadmin",
        icon: <FaIcons.FaTicketAlt />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Configuración",
        path: "/configurations",
        icon: <FaGear />,
        cName: "nav-text",
        hasOnClick: false,
      },
    ]
  },
  {
    title: "Salir",
    path: "/",
    icon: <IoMdExit />,
    cName: "nav-text",
    hasOnClick: true,
  },
];
